import * as React from "react";

import type { IconProps } from "./types";

export const ControllerIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <path
        d="M4.1 3.45H11.9C12.26 3.45 12.55 3.74 12.55 4.1V11.9C12.55 12.26 12.26 12.55 11.9 12.55H4.1C3.74 12.55 3.45 12.26 3.45 11.9V4.1C3.45 3.74 3.74 3.45 4.1 3.45ZM4.75 4.75V11.25H11.25V4.75H4.75Z"
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <rect x="6.35" y="6.35" width="3.3" height="3.3" rx="0.4" fill={color} />
      <path
        d="M5.35 1.5H6.65V3.45H5.35V1.5ZM9.35 1.5H10.65V3.45H9.35V1.5ZM5.35 12.55H6.65V14.5H5.35V12.55ZM9.35 12.55H10.65V14.5H9.35V12.55Z"
        fill={color}
      />
      <path
        d="M1.5 5.35H3.45V6.65H1.5V5.35ZM1.5 9.35H3.45V10.65H1.5V9.35ZM12.55 5.35H14.5V6.65H12.55V5.35ZM12.55 9.35H14.5V10.65H12.55V9.35Z"
        fill={color}
      />
    </svg>
  ),
);

export default ControllerIcon;
